/**
 * ui.ts
 * ----------------
 * Constants used in frontend components.
 */

export type PublicPortalViewPivot = 'event' | 'history' | 'status' | 'support';
export type UpdatePortalViewPivot = 'actions' | 'event' | 'history' | 'support';
export type UpdatePortalViewSection = 'event' | 'pending' | 'status';

export const PublicPortalEvent: PublicPortalViewPivot = 'event';
export const PublicPortalHistory: PublicPortalViewPivot = 'history';
export const PublicPortalStatus: PublicPortalViewPivot = 'status';
export const PublicPortalSupport: PublicPortalViewPivot = 'support';

export const ActionCenterPivot: UpdatePortalViewPivot = 'actions';
export const EventPivot: UpdatePortalViewPivot = 'event';
export const HistoryPivot: UpdatePortalViewPivot = 'history';
export const SupportPivot: UpdatePortalViewPivot = 'support';

export const EventSection: UpdatePortalViewSection = 'event';
export const PendingSection: UpdatePortalViewSection = 'pending';
export const StatusSection: UpdatePortalViewSection = 'status';
